import { Injectable } from '@angular/core';
import { keepUnstableUntilFirst } from '@angular/fire';
import { traceUntilFirst } from '@angular/fire/performance';
import { AppCheck, AppCheckTokenResult, getToken } from '@angular/fire/app-check';
import { Observable, from, EMPTY } from 'rxjs';
import { share } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppCheckService {

  constructor(private appCheck: AppCheck) { }

  getToken() : Observable<AppCheckTokenResult | undefined> {
    let appCheckTokenResponse;
    if (this.appCheck) {
      appCheckTokenResponse = from(getToken(this.appCheck)).pipe(
        // Cast operators to any to bypass type checking for Angular Fire operators
        traceUntilFirst('app-check') as any,
        keepUnstableUntilFirst as any,
        share(),
      );
    } else {
      appCheckTokenResponse = EMPTY;
    }
    return appCheckTokenResponse;
  }
}
